export default [
    {
        path: '/bank-statement/search',
        name: 'bank_statement_search',
        component: () => import('@src/bank-statement/bank-statement-search.vue'),
        meta: {
            title: 'Kontoauszug suchen',
        },
    },
];
